<template>
  <div
    class="custom-select"
    :class="{ open: open, disabled: disabled }"
    :tabindex="tabindex"
    @blur="open = false"
  >
    <div
      class="selected flex middle-xs justify-between items-center pl-small"
      :class="{ open: open }"
      @click.stop="!disabled ? (open = !open) : null"
    >
      <span v-if="selected" class="pl-small truncate-text">{{
        label ? selected[label] : selected
      }}</span>
      <span v-else class="text-sm text-gray-300 truncate-text">{{
        placeholder
      }}</span>
      <div class="flex">
        <pl-spinner v-if="isLoading" class="spinner-style"></pl-spinner>
        <i v-if="arrow" class="fas fa-angle-down text-gray-400 text-lg"></i>
      </div>
    </div>
    <div class="items" :class="{ selectHide: !open }">
      <div
        v-for="(option, index) of options"
        class="option-item"
        :key="index"
        @click="
          open = false;
          $emit('change', option);
        "
      >
        <slot v-if="cardHeader" v-bind:index="index"></slot>
        <span v-else>{{ label ? option[label] : option }}</span>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        open: false,
      };
    },
    props: {
      options: {
        type: Array,
        default() {
          return [];
        },
      },
      selected: {
        type: [String, Object],
        default() {
          return '';
        },
      },
      label: {
        type: String,
        default: null,
      },
      placeholder: {
        type: String,
        default() {
          return '';
        },
      },
      arrow: {
        type: Boolean,
        default: true,
      },
      disabled: {
        type: Boolean,
        default() {
          return false;
        },
      },
      isLoading: {
        type: Boolean,
        default() {
          return false;
        },
      },
      tabindex: {
        type: Number,
        required: false,
        default: 0,
      },
      cardHeader: {
        type: Boolean,
        default() {
          return false;
        },
      },
    },
  };
</script>
<style lang="stylus" scoped>
  @import '~app/global-stylus';

  .default.spinner-style {
    width: 16px;
    height: 16px;
  }

  .custom-select {
    position: relative;
    width: 100%;
    text-align: center;
    outline: none;
    padding:5px;
    /* height: 47px;
    line-height: 47px; */
    *
    {
        transition: all 200ms ease;
    }
    &.disabled {
      .selected {
        color: #b7b7b7;
        background-color: rgba(0, 0, 0, 0.04);
      }
    }
  }

  .custom-select .selected {
    padding-left: 1em;
    background-color: transparent;
    cursor: pointer;
    padding: 0 10px;
    user-select: none;
    margin: 0px;
    height: 100%
    &:hover {
      background-color: rgba(0, 0, 0, 0.04);
    }
  }

  .custom-select .selected.open {

  }

  .custom-select .selected:after {
    border: 5px solid transparent;
    font-size: 13px;
    color: pl-slate;
  }

  .custom-select .items {
    max-height: 125px
    color: pl-slate;
    overflow: auto;
    position: absolute;
    background-color: #fff;
    left: 0;
    right: 0;
    z-index: 1;
    box-shadow: 1px 1px 6px 0px rgba(0,0,0,0.1);
  }

  ::-webkit-scrollbar {
    display: block;
    width: 10px
    -webkit-appearance: none;
  }

  .custom-select .items div {
    color: pl-slate;
    padding-left: 1em;
    padding:10px;
    cursor: pointer;
    user-select: none;
  }

  .custom-select .items div:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }

  .selectHide {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// plSelect.vue?3da13691